//const for locally_available_warehouse_pincode
const locally_available_warehouse_pincode="560054,400007,110019,380052";
// Arrays for formatting the date
const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
const days = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
//const for locationDistrictMap
const locationDistrictMap = {
            36055302: {name: 'bangalore',pincode:'560054', etd:null},
            104755822895:{name:'ahmedabad',pincode:'380052',etd:null},
            104710504751:{name:'mumbai',pincode:'400007',etd:null},
            104710308143:{name:'delhi',pincode:'110019',etd:null},
            106145513775: {name: 'lucknow',pincode:'226004', etd:null}
 
          };



//Get Next Working Date
function getNextWorkingDate(holiday_list, cutoffTime = "14:00") {
    let additionalDays = 0;                 // Tracks how many days we skip (due to cutoff/holiday/Sunday)
    const today = new Date();               // Get current date & time

    // --- Step 1: Build today's cutoff time ---
    const [cutoffHour, cutoffMinute] = cutoffTime.split(":").map(Number); 
    // Extract hour & minute from cutoff string (e.g., "15:00" → 15, 0)

    const cutoffDate = new Date(today);     
    cutoffDate.setHours(cutoffHour, cutoffMinute, 0, 0);  
    // Create a "cutoff time" Date object (today at 2:00 PM by default)

    // --- Step 2: Decide if we start today or tomorrow ---
    let candidateDate = new Date(today);    // Start checking from today
    if (today > cutoffDate) {               // If current time has passed cutoff
      candidateDate.setDate(candidateDate.getDate() + 1); // Push to tomorrow
      additionalDays += 1;                  // Count this skipped day
    }

    // --- Step 3: Loop until a valid working day is found ---
    while (true) {
      // Format candidateDate into YYYY-MM-DD (to match holiday_list format)
      const yyyy = candidateDate.getFullYear();
      const mm = String(candidateDate.getMonth() + 1).padStart(2, "0");
      const dd = String(candidateDate.getDate()).padStart(2, "0");
      const dateStr = `${yyyy}-${mm}-${dd}`;

      const isHoliday = holiday_list.includes(dateStr);   // Check holiday list
      const isSunday = candidateDate.getDay() === 0;      // Sunday = 0

      if (!isHoliday && !isSunday) {
        // ✅ Found the next working day → exit loop
        break;
      }

      // Otherwise, skip to the next day and keep counting
      candidateDate.setDate(candidateDate.getDate() + 1);
      additionalDays += 1;
    }

    // --- Step 4: Format the final next working day into YYYY-MM-DD ---
    const yyyyN = candidateDate.getFullYear();
    const mmN = String(candidateDate.getMonth() + 1).padStart(2, "0");
    const ddN = String(candidateDate.getDate()).padStart(2, "0");
    const nextDateStr = `${yyyyN}-${mmN}-${ddN}`;

    // --- Step 5: Return result ---
    return {
      additionalDays,   // how many days were skipped
      nextDate: nextDateStr  // the next valid working day
    };
}

// AJAX API call
function ajaxPin(url, template, orderID) {
  return $.ajax({
    url: url,
    cache: false,
    async: true,
    beforeSend: function () {
      // console.log('before');
      if (template == "product") {
        $("#ResponsePin").html('<div class="pincodeMsg">Loading Delivery Timeline ...</div>');
        
      }
    },
    complete: function (data) {
        console.log('complete');
    },
  });
}

// filter the courier and return estimated delivery days for mode 0 and 1
function filterCourierDays(object, productType) {
  if (!Array.isArray(object)) {
    console.error("Error: 'object' is not an array");
    return null;
  }

  // Restricted products → prefer mode=0 but still calculate both
  const restrictedProducts = new Set(["Monitor", "Laptop Battery", "Laptop", "Desktop PC"]);
  const isRestricted = restrictedProducts.has(productType);

  // Store couriers separately by mode
  const courierMap = { mode0: [], mode1: [] };

  for (const courier of object) {
    if (!courier || !courier.courier_name) continue;

    const courierData = {
      days: parseInt(courier.estimated_delivery_days, 10) || 0,
      date: courier.etd,
      suppression_dates: courier.suppression_dates || [],
      mode: courier.mode
    };

    if (courier.mode === 0) courierMap.mode0.push(courierData);
    if (courier.mode === 1 && !isRestricted) courierMap.mode1.push(courierData); 
    // if restricted product → ignore mode1
  }

  // Helper: calculate min/max days for a list of couriers
  function getMinMax(couriers) {
    if (couriers.length === 0) {
      return { min: 0, max: 0, minDate: null, maxDate: null, suppression_dates: [] };
    }

    let { days: min, date: minDate, suppression_dates } = couriers[0];
    let { days: max, date: maxDate } = couriers[0];

    for (let i = 1; i < couriers.length; i++) {
      const { days, date, suppression_dates: sd } = couriers[i];
      if (days > 0) {
        if (days < min) {
          min = days;
          minDate = date;
          suppression_dates = sd || [];
        }
        if (days > max) {
          max = days;
          maxDate = date;
        }
      }
    }

    return { min, max, minDate, maxDate, suppression_dates };
  }

  // Return results for both modes
  return {
    mode0: getMinMax(courierMap.mode0),
    mode1: getMinMax(courierMap.mode1)
  };
}
// On keypress event of pincode 
$("#textpincodevalue").on("keypress", function (e) {
  var key = e.keyCode;
  if (key < 48 || key > 57) {
    e.preventDefault();
  }
    let enteredPincode = $("#textpincodevalue").val();
    // Storing pincode in cookie
    // localStorage.setItem("enteredPincode", enteredPincode);
    if (parseInt(enteredPincode) == 0) {
      e.preventDefault();
    }
    if (e.which == 13) {
       // console.log('enter press');
       e.preventDefault();
       getPincodeDetails();
    }
  });


//On button click of pincode  
$("#pincode").click(function () {
    getPincodeDetails();
});

// Cache to avoid refetching
let pincodeArray = null;

// Fetch and parse the array from the .txt file
async function heavyWeightFetchPincodes() {
  // URL lives inside the function ✅
  const Heavy_WEIGHT_PINCODE_URL = "https://cdn.shopify.com/s/files/1/1780/7915/files/PinCodeListHeavyProduct?v=1748266443";

  if (pincodeArray) return pincodeArray; // ✅ already cached

  const res = await fetch(Heavy_WEIGHT_PINCODE_URL, { cache: "force-cache" });
  if (!res.ok) throw new Error("Failed to fetch pincode data.");

  const text = await res.text();
  const jsonReady = text.replace(/'/g, '"'); // fix single → double quotes
  pincodeArray = JSON.parse(jsonReady);

  return pincodeArray;
}

// Check if a Heavy Weight Pincode Exists
async function isHeavyWeightPincodeAvailable(inputPin) {
  const pincodes = await heavyWeightFetchPincodes();
  return pincodes.includes(String(inputPin).trim());
}


function isSameDate(date1, date2) {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
}

//Pincode Tool Logic
async function getPincodeDetails(count1) {
  console.log("Call:", count1);

  let enteredPincode = $("#textpincodevalue").val();
  const found_pincode_in_heavy = await isHeavyWeightPincodeAvailable(enteredPincode);
  console.log("Heavy Weight Pincode" , found_pincode_in_heavy)

  // --- Current IST time ---
  const currentTime = new Date();
  const ISTTime = new Date(currentTime.getTime() + (330 + currentTime.getTimezoneOffset()) * 60000);

  // --- Cutoff 2 PM ---
  const cutOffTime = new Date(ISTTime);
  cutOffTime.setHours(14, 0, 0, 0);

  // Remaining time until cutoff
  let cutOffTimeLeft = "";
  if (ISTTime < cutOffTime) {
    const remainingMs = cutOffTime - ISTTime;
    const hrs = Math.floor(remainingMs / (1000 * 60 * 60));
    const mins = Math.floor((remainingMs % (1000 * 60 * 60)) / (1000 * 60));
    cutOffTimeLeft = hrs > 0 ? `${hrs} hr ${mins} min` : `${mins} min`;
  }

  // --- Validation ---
  if (enteredPincode.length === 0) {
    return $("#ResponsePin").html('<div class="NotAva"><p>Please enter a pincode.</p></div>');
  }
  if (enteredPincode.length !== 6) {
    return $("#ResponsePin").html('<div class="NotAva pincodeMsg"><span style="color: maroon;">Looks like the pincode is incorrect.</span></div><br>');
  }

  // --- API call ---
  const apiCall = `/apps/trackorder/checkProductAvailableLocation?q=${enteredPincode}&productId=${document.getElementById('pincodeContainer').title}&lst=${locally_available_warehouse_pincode}`;

  $.when(ajaxPin(apiCall, pageTemplate)).then((data) => {
    try {
      const holiday_list = data.pickuppincode_details?.holiday_list || [];
      const { additionalDays, nextDate } = getNextWorkingDate(holiday_list, "14:00");

      const availableInventory = (data.inventory?.Inventory || []).filter(i => i.available > 0);

      // Map warehouses
      const warehouseMap = {};
      (data.wh || []).forEach(wh => {
        warehouseMap[wh.Pincode] = {
          district: (wh.District || "").toUpperCase(),
          state: (wh.State || "").toUpperCase()
        };
      });

      const enteredDistrict = (data.pickuppincode_details?.District || "").toUpperCase();
      const enteredState = (data.pickuppincode_details?.State || "").toUpperCase();

      // --- Local availability check (faster with .some) ---
      const isLocallyAvailable = availableInventory.some(item => {
        const loc = locationDistrictMap[item.location_id];
        if (!loc) return false;
        const wh = warehouseMap[loc.pincode];
        return wh && (wh.district === enteredDistrict || (enteredState === "DELHI" && wh.state === "DELHI"));
      });

      let message = "Delivery timeline unavailable due to temporary issue.";
      console.log("Get The date")
      
      // --- If locally available ---
      if (isLocallyAvailable) {
        if (additionalDays === 0) {
          message = `<span>Choose <b>Local Delivery</b>, get it by <b>today 9PM</b>,if ordered in <b>${cutOffTimeLeft}</b>.</span>`;
        } else if (additionalDays === 1) {
          message = `<span>Choose <b>Local Delivery</b>, get it by <b>tomorrow</b>.</span>`;
        } else {
          const nextdate1 = new Date(nextDate);
          standardDateStr1 = `${days[nextdate1.getDay()]}, ${months[nextdate1.getMonth()]} ${nextdate1.getDate()}`;
          console.log(standardDateStr1)
          message = `<span>Choose <b>Local Delivery</b>, get it by <b>${standardDateStr1}</b>.</span>`;
        }
        return $("#ResponsePin").html(`<div class="pincodeMsg">${message}</div><br>`);
      }

      // --- Else → Courier delivery ---
      // const nearest_pincode = (availableInventory[0]?.location_id && locationDistrictMap[availableInventory[0].location_id]?.pincode) || "560094";
      // Find nearest pincode based on absolute distance
        let nearest_pincode = "560094"; // default fallback

        if (availableInventory.length > 0) {
          let minDistance = Infinity;

          availableInventory.forEach(item => {
            const loc = locationDistrictMap[item.location_id];
            if (loc?.pincode) {
              // Calculate distance ignoring sign
              const distance = Math.abs(Number(loc.pincode) - Number(data.pickuppincode_details.Pincode));
              if (distance < minDistance) {
                minDistance = distance;
                nearest_pincode = loc.pincode;
              }
            }
          });
        }

      const productWeight = data?.inventory?.ProductWeight ?? 1.5;
      const productType = data?.inventory?.ProductType || "";

      const apiCall1 = `/apps/trackorder/checkShiprocketDetailsforETD?q=${nearest_pincode}&pincode=${data.pickuppincode_details.Pincode}&weight=${productWeight}`;

      $.when(ajaxPin(apiCall1, pageTemplate)).then((data1) => {
       


        // --- Heavy products ---
        if (
          found_pincode_in_heavy &&
          ["Monitor", "Laptop Battery", "Laptop", "Desktop PC"].includes(productType)
        ) {
          // Heavy → only Standard delivery (+3 days)
          const nextDateObj = new Date(nextDate);
          nextDateObj.setDate(nextDateObj.getDate() + 3);
          const standardDate = `${days[nextDateObj.getDay()]}, ${months[nextDateObj.getMonth()]} ${nextDateObj.getDate()}`;

          message = `<span>Arrives by ${standardDate}, with <b>Express Ship</b>.</span> `;
        } else {
          // --- Normal products ---
          const courierAll = filterCourierDays(
            data1.data["available_courier_companies"],
            productType
          );

          let expressDateStr = "";
          let standardDateStr = "";
          let expressDateObj;
          // Express (mode1)
          if (courierAll.mode1?.min || courierAll.mode1?.minDate) {
            

            if (courierAll.mode1.min) {
              // Use current date + min days + additionalDays
              expressDateObj = new Date(); // today
              expressDateObj.setDate(expressDateObj.getDate() + courierAll.mode1.min + additionalDays);
            } else {
              // Use minDate from courier + additionalDays
              expressDateObj = new Date(courierAll.mode1.minDate);
              expressDateObj.setDate(expressDateObj.getDate() + additionalDays);
            }

            expressDateStr = `${days[expressDateObj.getDay()]}, ${months[expressDateObj.getMonth()]} ${expressDateObj.getDate()}`;
          }

          // Standard (mode0)
          if (courierAll.mode0?.min || courierAll.mode0?.minDate) {
            let standardDateObj;

            if (courierAll.mode0.min) {
              // Use current date + min days + additionalDays
              standardDateObj = new Date(); // today
              standardDateObj.setDate(standardDateObj.getDate() + courierAll.mode0.min + additionalDays);
            } else {
              // Use minDate from courier + additionalDays
              standardDateObj = new Date(courierAll.mode0.minDate);
              standardDateObj.setDate(standardDateObj.getDate() + additionalDays);
            }
            // Check if both dates are same
            try {
              if (expressDateObj.toDateString() === standardDateObj.toDateString()) {
                standardDateObj.setDate(standardDateObj.getDate() + 2);
              }
            } catch (err) {
              console.log("Express Ship|0.");
            }
         

            standardDateStr = `${days[standardDateObj.getDay()]}, ${months[standardDateObj.getMonth()]} ${standardDateObj.getDate()}`;
          }
          console.log(standardDateStr,expressDateStr)
          // --- Final combined message ---
          if (productType == "Laptop Battery"){
              message = `<span><b>Free Shipping</b> arrives by ${standardDateStr}.</span>`;
            

          }
          else if (expressDateStr && standardDateStr) {
            if (additionalDays === 0 && cutOffTimeLeft) {
              message = `<span>Arrives by ${expressDateStr}, with <b>Express Ship</b>. Order in <b>${cutOffTimeLeft}</b>.<b>Free Shipping</b> arrives by ${standardDateStr}.</span>`;
            } else {
              message = `<span>Arrives by ${expressDateStr}, with <b>Express Ship</b>.<br> <b>Free Shipping</b> arrives by ${standardDateStr}.</span>`;
            }
          } else if (expressDateStr) {
            if (additionalDays === 0 && cutOffTimeLeft) {
              message = `<span>Arrives by ${expressDateStr}, with <b>Express Ship</b>. Order in <b>${cutOffTimeLeft}</b>.</span>`;
            } else {
              message = `<span>Arrives by ${expressDateStr}, with <b>Express Ship</b>.</span>`;
            }
          } else if (standardDateStr) {
            message = `<span>Arrives by ${standardDateStr}, with <b>Express Ship</b>.</span>`;
          }
        }


        $("#ResponsePin").html(`<div class="pincodeMsg">${message}</div><br>`);
      });
    } catch (e) {
      console.error("Error parsing response", e);
    }
  });
}


 const checkoutDrawerBtn = document.getElementById("CartDrawer-Checkout");




 /**
           * Validate GST number on cart page
           * - Ensures input matches 15-char GSTIN format
           * - Highlights input field red if invalid
           * - Enables checkout button only if valid
          */
          function validate_gst_number_for_cart_page(checkoutBtn1,inputEl1) {
                  // Get elements
                  const inputEl = document.getElementById(inputEl1);
                  

                  // Clean input: trim spaces + force uppercase
                  const val = inputEl.value.trim().toUpperCase();
                  inputEl.value = val;

                  /**
                   * GST regex format (15 chars):
                   *  1-2   → State code (2 digits)
                   *  3-7   → PAN letters (A-Z, 5 chars)
                   *  8-11  → PAN digits (0-9, 4 chars)
                   *  12    → PAN letter (A-Z, 1 char)
                   *  13    → Entity code (1-9 or A-Z)
                   *  14    → Always "Z"
                   *  15    → Checksum (0-9 or A-Z)
                   *
                   * ✅ Example: 29ABCDE1234F1Z5
                   */
                  const gst_regex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;

                  // Validate GST
                  if (gst_regex.test(val)) {
                      // ✅ GST valid → enable checkout
                      checkoutBtn1.disabled = false;
                      checkoutBtn1.style.cssText = "pointer-events:auto;opacity:1";
                      inputEl.style.cssText = "border:2px solid #000;border-radius:5px";
                      return true;
                  } else {
                      // ❌ GST invalid → disable checkout
                      checkoutBtn1.disabled = true;
                      checkoutBtn1.style.cssText = "pointer-events:none;opacity:0.5";
                      inputEl.style.cssText = "border:2px solid red;border-radius:5px";
                      return false;
                  }
          }



 // ================================================
              // GST Checkbox Toggle for Cart Drawer Page
              // -----------------------------------------------
              // - Shows/Hides GST input field based on checkbox
              // - Disables/enables checkout button accordingly
              // - Calls validation when GST field is shown
              // - Optimized: no jQuery, cached DOM elements
              // ================================================

              // Cache DOM elements (faster than querying every time)
              const gstCheckboxDrawer = document.getElementById("GST_Order_CheckBox_Drawer");
              const gstFieldDrawer = document.getElementById("cart_note_gst_Drawer");
              
              // Attach listener when checkbox value changes
        gstCheckboxDrawer.addEventListener("change", function () {
              if (this.checked) {
                  // ✅ Case: Checkbox checked → GST entry required
                  // Show GST input field
                  gstFieldDrawer.style.display = "block";

                  // Disable checkout until valid GST is entered
                  checkoutDrawerBtn.style.pointerEvents = "none"; // prevent clicks
                  checkoutDrawerBtn.style.opacity = "0.5";        // greyed out
                  checkoutDrawerBtn.disabled = true;              // HTML disable

                  // Run GST validation (to check existing input immediately)
                  validate_gst_number_for_cart_page(checkoutDrawerBtn,'Cart-addition_note_Drawer');
              } else {
                  // ✅ Case: Checkbox unchecked → GST not required
                  // Hide GST input field
                  gstFieldDrawer.style.display = "none";

                  // Enable checkout normally
                  checkoutDrawerBtn.style.pointerEvents = "auto";
                  checkoutDrawerBtn.style.opacity = "1";
                  checkoutDrawerBtn.disabled = false;
              }
        });


      const gstInputDrawer = document.getElementById("Cart-addition_note_Drawer");


      gstInputDrawer.addEventListener("input", function () {
        // Trim spaces & enforce uppercase
        this.value = this.value.trim().toUpperCase();

        if (this.value.length >= 15) {
          // ✅ Run GST validation if length >= 15
          validate_gst_number_for_cart_page(checkoutDrawerBtn,'Cart-addition_note_Drawer');

          // Prevent typing beyond 15 chars
          this.value = this.value.slice(0, 15);
        } else {
          // ❌ Not enough characters → Disable checkout
          console.log("GST number too short");
          checkoutDrawerBtn.style.pointerEvents = "none";
          checkoutDrawerBtn.style.opacity = "0.5";
          checkoutDrawerBtn.disabled = true;
        }
      });


// Java script if template is Cart Page
if(pageTemplate == 'cart'){






        //Cart GST Input Function and validation 
        var gst_lines='';

        const checkoutBtn = document.getElementById("checkout");


         

              // ================================================
              // GST Checkbox Toggle for Cart Page
              // -----------------------------------------------
              // - Shows/Hides GST input field based on checkbox
              // - Disables/enables checkout button accordingly
              // - Calls validation when GST field is shown
              // - Optimized: no jQuery, cached DOM elements
              // ================================================

              // Cache DOM elements (faster than querying every time)
              const gstCheckbox = document.getElementById("GST_Order_CheckBox");
              const gstField = document.getElementById("cart_note_gst");
              
              // Attach listener when checkbox value changes
              gstCheckbox.addEventListener("change", function () {
              if (this.checked) {
                  // ✅ Case: Checkbox checked → GST entry required
                  // Show GST input field
                  gstField.style.display = "block";

                  // Disable checkout until valid GST is entered
                  checkoutBtn.style.pointerEvents = "none"; // prevent clicks
                  checkoutBtn.style.opacity = "0.5";        // greyed out
                  checkoutBtn.disabled = true;              // HTML disable

                  // Run GST validation (to check existing input immediately)
                  validate_gst_number_for_cart_page(checkoutBtn,'Cart-addition_note');
              } else {
                  // ✅ Case: Checkbox unchecked → GST not required
                  // Hide GST input field
                  gstField.style.display = "none";

                  // Enable checkout normally
                  checkoutBtn.style.pointerEvents = "auto";
                  checkoutBtn.style.opacity = "1";
                  checkoutBtn.disabled = false;
              }
              });

      // ====================================================
      // GST Input Validation (Cart Page)
      // ----------------------------------------------------
      // - Listens for typing in GST input field
      // - Trims extra spaces automatically
      // - Calls GST validation once min length (15 chars) reached
      // - Prevents typing beyond 15 characters
      // - Disables checkout button until valid GST entered
      // ====================================================

      const gstInput = document.getElementById("Cart-addition_note");


      gstInput.addEventListener("input", function () {
        // Trim spaces & enforce uppercase
        this.value = this.value.trim().toUpperCase();

        if (this.value.length >= 15) {
          // ✅ Run GST validation if length >= 15
          validate_gst_number_for_cart_page(checkoutBtn,'Cart-addition_note');

          // Prevent typing beyond 15 chars
          this.value = this.value.slice(0, 15);
        } else {
          // ❌ Not enough characters → Disable checkout
          console.log("GST number too short");
          checkoutBtn.style.pointerEvents = "none";
          checkoutBtn.style.opacity = "0.5";
          checkoutBtn.disabled = true;
        }
      });
      
window.addEventListener("load", (event) => {
   pef_cart_Discount()

});
   

  
      function observeTotalValueChanges1() {
        let lastValue = null;

        const container =document.querySelector('#main-cart-footer .totals, body'); 
        if (!container) return;

        const observer = new MutationObserver(() => {
          const el = document.querySelector('#main-cart-footer .totals .totals__total-value');
          if (!el) return;

          const newValue = el.textContent.trim();
          if (newValue !== lastValue) {
            lastValue = newValue;
            pef_cart_Discount(); // run only when value changes
          }
        });

        observer.observe(container, {
          childList: true,
          subtree: true
        });

        // Initial value check
        const el = document.querySelector('#main-cart-footer .totals .totals__total-value');
        if (el) lastValue = el.textContent.trim();
      }

      // Run on page load
  observeTotalValueChanges1();



}
// End of Cart Javascript

console.log(pageTemplate)

// Java script if template is Cart Page
if(pageTemplate == 'product'){
    

      // Check weather the geolocation work or not
    function getPostcodeAddessLocation() {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(showLatLogPosition);
      } else { 
        console.log("Geolocation is not supported by this browser.")
      }
    }
    // Find Lat Long Value
    function showLatLogPosition(position) {
      // console.log("Latitude: " + position.coords.latitude + 
      // "Longitude: " + position.coords.longitude)
      const lat=position.coords.latitude;
      const lon=position.coords.longitude;
          
        try{ 
            let url=`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lon}`; 
            fetch(url).then(res=>res.json()).then( (data) => {
                // console.log(data.address)
               if (data.address.postcode !='undefined' && data.address.postcode.length == 6 ){
                 try{
                    document.getElementById('textpincodevalue').value=data.address.postcode;
                    getPincodeDetails(1);
                 }
                 catch{ console.log(" ")
                 }
                } else{
                     document.getElementById('textpincodevalue').value='560094';
                     getPincodeDetails(1);
                }
               })
            
          } catch(err){
                console.log(err);
                document.getElementById('textpincodevalue').value='560094';
               getPincodeDetails(1);
          }
    }
    
 
    getPostcodeAddessLocation();





    async function pef_Discount() {
          console.log("Checking Discount")
          document.querySelectorAll(".discount_offer_product_area").forEach(container => {
            container.style.display = "block";

            const titleEl = container.querySelector(".discount_offer_product_tile");
            if (titleEl) titleEl.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/1780/7915/files/offer-tool-loading-image.gif?v=1758530354" 
       alt="Offer" 
       style="width:30px; height:30px; vertical-align:middle; margin-right:8px;"><strong>loading offers..</strong>`;
            const mainEl = container.querySelector(".main_product_offers");
            mainEl.innerHTML=''
            const hiddenEl = container.querySelector(".hidden_product_offers");
            hiddenEl.innerHTML = '';

            const toggleBtn = container.querySelector(".toggle_discount_product_offers");
            if (toggleBtn) {
              toggleBtn.style.display = "none";
            }
          
          });
          const cartItems = document.getElementsByClassName("show_discount_product_offer");
          if (!cartItems.length) return;

          // Collect unique product IDs from titles
          const productIds = Array.from(
            new Set(
              Array.from(cartItems)
                .map(item => item.title)
                .filter(title => title && title.length > 1)
            )
          );
        console.log(productIds)
          if (!productIds.length) {
            document.querySelectorAll(".discount_offer_product_area").forEach(el => {
              el.style.display = 'none';
            });
            return;
          }

          let discountData = [];

          // Run all API calls in parallel
          const requests = productIds.map(pid => {
            const apiCall = `/apps/trackorder/discount?productId=${pid}`;
            return ajaxDiscount(apiCall, pageTemplate); // ajaxDiscount defined elsewhere
          });

          // Wait for all API responses
          const results = await Promise.all(requests);
          results.forEach(r => discountData.push(...r));
          console.log(discountData)
          if (!discountData.length) {
            document.querySelectorAll(".discount_offer_product_area").forEach(el => {
              el.style.display = 'none';
            });
            return;
          }

          // Process unique discount codes
          let discountCodes = new Set();
          let mainOffersHTML = "";
          let hiddenOffersHTML = "";
          let offerCount = 0;

          for (let d of discountData) {
            if (discountCodes.has(d.code)) continue;
            discountCodes.add(d.code);
            offerCount++;

            let off = d.off || 0;
            if (typeof off === "string" && off.includes("₹")) {
              off = off.slice(0, off.indexOf("."));
            }

            let minPrice = d.min_purchase_price;
            if (minPrice) {
              if (minPrice.includes("₹")) minPrice = minPrice.slice(minPrice.indexOf("₹"), minPrice.indexOf("."));
              else minPrice = minPrice.slice(0, minPrice.indexOf("."));
              minPrice = kFormatter(Math.floor(minPrice));
            }

            let regex_bxgy_off_on_item = /at ₹([\d,]+(?:\.\d{1,2})?) off/;
            
            
            let match = d.summary.match(regex_bxgy_off_on_item);
            
            let offerHTML = "";
            if (d.type === "bxgy_spen_discount_get_free" && minPrice && match) {
              let match_format_valueOff = match[1].replace(/\.00$/, '');
              offerHTML = `<p><img src="https://cdn.shopify.com/s/files/1/1780/7915/files/icon-coupon.svg?v=1758540599" alt="Coupon" style="width:40px; height:auto; vertical-align:middle; "> 
              <strong>${d.code}</strong> - Shop for ${minPrice} & get ₹${match_format_valueOff} OFF on <a href="${d.free_item_url}" target="_blank">${d.product_type}</a>.</p>`;
            }else if (d.type === "bxgy_spen_discount_get_free" && minPrice) {
              offerHTML = `<p><img src="https://cdn.shopify.com/s/files/1/1780/7915/files/icon-coupon.svg?v=1758540599" alt="Coupon" style="width:40px; height:auto; vertical-align:middle; "> 
              <strong>${d.code}</strong> Get Free <a href="${d.free_item_url}" target="_blank">${d.product_type}</a> on purchase of <strong>Minimum ${minPrice}</strong></p>`;
            } else if (minPrice && !d.min_quantity) {
              offerHTML = `<p><img src="https://cdn.shopify.com/s/files/1/1780/7915/files/icon-coupon.svg?v=1758540599" alt="Coupon" style="width:40px; height:auto; vertical-align:middle; "> 
               <strong>${d.code}</strong> Get <strong>${off} Off</strong> on purchase of <strong>Minimum ${minPrice}</strong></p>`;
            } else if (!minPrice && d.min_quantity === "1") {
              offerHTML = `<p><img src="https://cdn.shopify.com/s/files/1/1780/7915/files/icon-coupon.svg?v=1758540599" alt="Coupon" style="width:40px; height:auto; vertical-align:middle; "> 
               <strong>${d.code}</strong> Get <strong>${off} Off</strong> on this product</p>`;
            } else if (!minPrice && d.min_quantity && d.min_quantity !== "1" && d.code.startsWith("BULKTPS")) {
              offerHTML = `<p><img src="https://cdn.shopify.com/s/files/1/1780/7915/files/icon-coupon.svg?v=1758540599" alt="Coupon" style="width:40px; height:auto; vertical-align:middle; "> 
                      <strong>${d.code}</strong> Get <strong>${off} Off</strong> on each additional item in your cart</p>`;
            }else if (!minPrice && d.min_quantity && d.min_quantity !== "1" && d.code.startsWith("NASCOMBO")) {
              offerHTML = `<p><img src="https://cdn.shopify.com/s/files/1/1780/7915/files/icon-coupon.svg?v=1758540599" alt="Coupon" style="width:40px; height:auto; vertical-align:middle; "> 
                      <strong>${d.code}</strong> Get <strong>${off} Off</strong> on purchase of min. ${d.min_quantity} items from NAS Solution</p>`;
            }else if (!minPrice && d.min_quantity && d.min_quantity !== "1") {
              offerHTML = `<p><img src="https://cdn.shopify.com/s/files/1/1780/7915/files/icon-coupon.svg?v=1758540599" alt="Coupon" style="width:40px; height:auto; vertical-align:middle; "> 
               <strong>${d.code}</strong> Get <strong>${off} Off</strong> on purchase of <strong>Minimum ${d.min_quantity} Qty</strong></p>`;
            } else {
              offerHTML = `<p><img src="https://cdn.shopify.com/s/files/1/1780/7915/files/icon-coupon.svg?v=1758540599" alt="Coupon" style="width:40px; height:auto; vertical-align:middle; "> 
               <strong>${d.code}</strong> Get <strong>${off} Off</strong> on this product</p>`;
            }

            if (offerCount <= 2) mainOffersHTML += offerHTML;
            else hiddenOffersHTML += offerHTML;
          }

          // Update all matching containers (since IDs repeat)
          document.querySelectorAll(".discount_offer_product_area").forEach(container => {
            container.style.display = "block";

            const titleEl = container.querySelector(".discount_offer_product_tile");
            if (titleEl) titleEl.innerHTML = `<strong>${offerCount} Offers Available</strong>`;

            const mainEl = container.querySelector(".main_product_offers");
            if (mainEl) mainEl.innerHTML = mainOffersHTML;

            const hiddenEl = container.querySelector(".hidden_product_offers");
            if (hiddenEl) hiddenEl.innerHTML = hiddenOffersHTML;

            const toggleBtn = container.querySelector(".toggle_discount_product_offers");
            if (toggleBtn) {
              toggleBtn.style.display = hiddenOffersHTML ? "flex" : "none";
            }
          });

          // Save product IDs for JS/template use
          document.querySelectorAll("#discountOfferProductContainer").forEach(el => {
            el.dataset.productId = productIds.join(",");
          });
        }
        pef_Discount() 
}

//Find Discount offers  
function kFormatter(num) {
  if (num > 99999) {
    return '₹' + Math.floor(num / 100000) + 'L';
  } else if (num > 999) {
    return '₹' + Math.floor(num / 1000) + 'K';
  } else {
    return num;
  }
}


async function ajaxDiscount(url, pageTemplate) {
  try {
    const response = await fetch(
      url + (pageTemplate ? `&pageTemplate=${pageTemplate}` : ''), 
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json"
        }
      }
    );

    if (!response.ok) throw new Error("Network response was not ok");

    const data = await response.json();

    // wait for 1 second instead of 5
    await new Promise(resolve => setTimeout(resolve, 1000));

    return Array.isArray(data) ? data : [];
  } catch (err) {
    console.error("Error fetching discount:", err);
    return [];
  }
}






async function pef_cart_Discount() {
  console.log("Checking Cart Discount")
  document.querySelectorAll(".discount_offer_area1").forEach(container => {
    container.style.display = "block";

    const titleEl = container.querySelector(".discount_offer_tile");
    if (titleEl) titleEl.innerHTML = `<img src="https://cdn.shopify.com/s/files/1/1780/7915/files/offer-tool-loading-image.gif?v=1758530354" 
       alt="Offer" 
       style="width:30px; height:30px; vertical-align:middle; margin-right:8px;"><strong>loading offers..</strong>`;
    const mainEl = container.querySelector(".main_offers");
    mainEl.innerHTML=''
    const hiddenEl = container.querySelector(".hidden_offers");
    hiddenEl.innerHTML = '';

    const toggleBtn = container.querySelector(".toggle_discount_offers");
    if (toggleBtn) {
      toggleBtn.style.display = "none";
    }
  
  });
  const cartItems = document.getElementsByClassName("cart-item__details");
  if (!cartItems.length) return;

  // Collect unique product IDs from titles
  const productIds = Array.from(
    new Set(
      Array.from(cartItems)
        .map(item => item.title)
        .filter(title => title && title.length > 1)
    )
  );
  console.log(productIds)

  if (!productIds.length) {
    document.querySelectorAll(".discount_offer_area1").forEach(el => {
      el.style.display = 'none';
    });
    return;
  }

  let discountData = [];

  // Run all API calls in parallel
  const requests = productIds.map(pid => {
    const apiCall = `/apps/trackorder/discount?productId=${pid}`;
    return ajaxDiscount(apiCall, pageTemplate); // ajaxDiscount defined elsewhere
  });

  // Wait for all API responses
  const results = await Promise.all(requests);
  results.forEach(r => discountData.push(...r));

  if (!discountData.length) {
    document.querySelectorAll(".discount_offer_area1").forEach(el => {
      el.style.display = 'none';
    });
    return;
  }

  // Process unique discount codes
  let discountCodes = new Set();
  let mainOffersHTML = "";
  let hiddenOffersHTML = "";
  let offerCount = 0;

  for (let d of discountData) {
    if (discountCodes.has(d.code)) continue;
    discountCodes.add(d.code);
    offerCount++;

    let off = d.off || 0;
    if (typeof off === "string" && off.includes("₹")) {
      off = off.slice(0, off.indexOf("."));
    }

    let minPrice = d.min_purchase_price;
    if (minPrice) {
      if (minPrice.includes("₹")) minPrice = minPrice.slice(minPrice.indexOf("₹"), minPrice.indexOf("."));
      else minPrice = minPrice.slice(0, minPrice.indexOf("."));
      minPrice = kFormatter(Math.floor(minPrice));
    }
    let regex_bxgy_off_on_item = /at ₹([\d,]+(?:\.\d{1,2})?) off/;
            
            
    let match = d.summary.match(regex_bxgy_off_on_item);
    let offerHTML = "";
    if (d.type === "bxgy_spen_discount_get_free" && minPrice && match) {
              let match_format_valueOff = match[1].replace(/\.00$/, '');
              offerHTML = `<p><img src="https://cdn.shopify.com/s/files/1/1780/7915/files/icon-coupon.svg?v=1758540599" alt="Coupon" style="width:40px; height:auto; vertical-align:middle; "> 
              <strong>${d.code}</strong> - Shop for ${minPrice} & get ₹${match_format_valueOff} OFF on <a href="${d.free_item_url}" target="_blank">${d.product_type}</a>.</p>`;
    }else if (d.type === "bxgy_spen_discount_get_free" && minPrice) {
              offerHTML = `<p><img src="https://cdn.shopify.com/s/files/1/1780/7915/files/icon-coupon.svg?v=1758540599" alt="Coupon" style="width:40px; height:auto; vertical-align:middle; "> 
              <strong>${d.code}</strong> Get Free <a href="${d.free_item_url}" target="_blank">${d.product_type}</a> on purchase of <strong>Minimum ${minPrice}</strong></p>`;
    } else if (minPrice && !d.min_quantity) {
      offerHTML = `<p><img src="https://cdn.shopify.com/s/files/1/1780/7915/files/icon-coupon.svg?v=1758540599" alt="Coupon" style="width:40px; height:auto; vertical-align:middle; ">
               <strong>${d.code}</strong> Get <strong>${off} Off</strong> on purchase of <strong>Minimum ${minPrice}</strong></p>`;
    } else if (!minPrice && d.min_quantity === "1") {
      offerHTML = `<p><img src="https://cdn.shopify.com/s/files/1/1780/7915/files/icon-coupon.svg?v=1758540599" alt="Coupon" style="width:40px; height:auto; vertical-align:middle; ">
               <strong>${d.code}</strong> Get <strong>${off} Off</strong> on this product</p>`;
    } else if (!minPrice && d.min_quantity && d.min_quantity !== "1" && d.code.startsWith("BULKTPS")) {
      offerHTML = `<p><img src="https://cdn.shopify.com/s/files/1/1780/7915/files/icon-coupon.svg?v=1758540599" alt="Coupon" style="width:40px; height:auto; vertical-align:middle; "> 
               <strong>${d.code}</strong> Get <strong>${off} Off</strong> on each additional item in your cart</p>`;
    }else if (!minPrice && d.min_quantity && d.min_quantity !== "1" && d.code.startsWith("NASCOMBO")) {
      offerHTML = `<p><img src="https://cdn.shopify.com/s/files/1/1780/7915/files/icon-coupon.svg?v=1758540599" alt="Coupon" style="width:40px; height:auto; vertical-align:middle; "> 
               <strong>${d.code}</strong> Get <strong>${off} Off</strong> on purchase of min. ${d.min_quantity} items from NAS Solution</p>`;
    }else if (!minPrice && d.min_quantity && d.min_quantity !== "1") {
      offerHTML = `<p><img src="https://cdn.shopify.com/s/files/1/1780/7915/files/icon-coupon.svg?v=1758540599" alt="Coupon" style="width:40px; height:auto; vertical-align:middle; "> 
               <strong>${d.code}</strong> Get <strong>${off} Off</strong> on purchase of <strong>Minimum ${d.min_quantity} Qty</strong></p>`;
    } else {
      offerHTML = `<p><img src="https://cdn.shopify.com/s/files/1/1780/7915/files/icon-coupon.svg?v=1758540599" alt="Coupon"  style="width:40px; height:auto; vertical-align:middle; "> 
               <strong>${d.code}</strong> Get <strong>${off} Off</strong> on this product</p>`;
    }

    if (offerCount <= 2) mainOffersHTML += offerHTML;
    else hiddenOffersHTML += offerHTML;
  }

  // Update all matching containers (since IDs repeat)
  document.querySelectorAll(".discount_offer_area1").forEach(container => {
    container.style.display = "block";

    const titleEl = container.querySelector(".discount_offer_tile");
    if (titleEl) titleEl.innerHTML = `<strong>${offerCount} Offers Available</strong>`;

    const mainEl = container.querySelector(".main_offers");
    if (mainEl) mainEl.innerHTML = mainOffersHTML;

    const hiddenEl = container.querySelector(".hidden_offers");
    if (hiddenEl) hiddenEl.innerHTML = hiddenOffersHTML;

    const toggleBtn = container.querySelector(".toggle_discount_offers");
    if (toggleBtn) {
      toggleBtn.style.display = hiddenOffersHTML ? "flex" : "none";
    }
  });

  // Save product IDs for JS/template use
  document.querySelectorAll("#discountOfferContainer").forEach(el => {
    el.dataset.productId = productIds.join(",");
  });
}

$(document).on("click", ".toggle_discount_offers", function () {
  const $hiddenOffers = $(this).siblings(".hidden_offers");

  if ($hiddenOffers.is(":visible")) {
    $hiddenOffers.slideUp(200);
    $(this).text("+ Offers");
  } else {
    $hiddenOffers.slideDown(200);
    $(this).text("- Offers");
  }
});


$(document).on("click", ".toggle_discount_product_offers", function () {
  const $hiddenOffers = $(this).siblings(".hidden_product_offers");

  if ($hiddenOffers.is(":visible")) {
    $hiddenOffers.slideUp(200);
    $(this).text("+ Offers");
  } else {
    $hiddenOffers.slideDown(200);
    $(this).text("- Offers");
  }
});

function observeTotalValueChanges() {
  let lastValue = null;

  const container = document.querySelector('.totals, .cart-drawer, body'); 
  if (!container) return;

  const observer = new MutationObserver(() => {
    const el = document.querySelector('.totals__total-value');
    if (!el) return;

    const newValue = el.textContent.trim();
    if (newValue !== lastValue) {
      lastValue = newValue;
      pef_cart_Discount(); // run only when value changes
    }
  });

  observer.observe(container, {
    childList: true,
    subtree: true
  });

  // Initial value check
  const el = document.querySelector('.totals__total-value');
  if (el) lastValue = el.textContent.trim();
}

// Run on page load
observeTotalValueChanges();



// Whenever the Cart draw is display the pef_cart_Discount() is getting refresh
const drawerEl = document.querySelector(".drawer");

if (drawerEl) {
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.attributeName === "class") {
        if (drawerEl.classList.contains("active")) {
          pef_cart_Discount();
        }
      }
    });
  });

  observer.observe(drawerEl, { attributes: true });
}